export default __webpack_public_path__ + "static/media/home-decor-img-15.49a946b6.png";